export const SPECIAL_SECTION_CACHE_KEY = "special-section"
export const SPECIAL_SECTION_CACHE_KEY_INFINITE = "special-section-infinite"